import { z } from "zod";
import { parseFields } from "../../schemaParser.js";
import { getFieldMeta } from "../helpers.js";
/**
 * Validates a checkbox list field in the form.
 *
 * @param data The form data to validate.
 * @param field The field to validate.
 * @param refinementContext The refinement context to add issues to.
 */
export function validateCheckboxList(data, field, refinementContext) {
    let value = data[field.field];
    try {
        if (typeof value !== "string") {
            throw new Error("Value is not a string.");
        }
        value = JSON.parse(value);
        if (!Array.isArray(value)) {
            throw new Error("Value is not an array.");
        }
        if (field.optional === false && value.length === 0) {
            throw new Error("At least one checkbox must me checked");
        }
        const validValues = field.options.map((option) => option.value);
        for (const val of value) {
            if (typeof val !== "string" &&
                typeof val !== "number" &&
                typeof val !== "boolean") {
                throw new Error(`A(n) ${typeof val} is not assignable to a checkbox list value.`);
            }
            if (!validValues.includes(val)) {
                throw new Error(`${val} is not a valid option in ${JSON.stringify(validValues)}.`);
            }
        }
    }
    catch (e) {
        refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: `The field "${getFieldMeta(field).label}" has an invalid encoded value: ${e.message}.`,
            path: [field.field],
        });
    }
}
/**
 * Validates the checkbox lists in the form.
 *
 * @param data The form data to validate.
 * @param refinementContext The refinement context to add issues to.
 * @param shape The shape of the schema.
 * @returns The refinement context with any issues added.
 */
export function validateCheckboxLists(data, refinementContext, shape) {
    const fields = parseFields(shape, null);
    const checkboxLists = fields.filter((field) => field.settings?.isCheckBoxList);
    for (const field of checkboxLists) {
        validateCheckboxList(data, field, refinementContext);
    }
    return refinementContext;
}
//# sourceMappingURL=checkboxLists.js.map